import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { agitationPoints } from '../../data/salesContent';
export function PainSection() {
  return <section className="bg-ink-soft px-5 py-20 md:py-28" data-id="element-177" data-mp="2rijcdy8ptikx">
      <div className="mx-auto max-w-4xl" data-id="element-178" data-mp="2rl5j5vns7u23">
        <SectionHeading title="¿Te pasa esto antes de dar una clase?" data-id="element-179" data-mp="2mkhmatcvgizy" />
        <ul className="mt-12 space-y-3" data-id="element-180" data-mp="2hkv5k9xu4kme">
          {agitationPoints.map(p => <li key={p} className="flex items-center gap-4 rounded-xl border-l-4 border-red-400/60 bg-ink px-5 py-5 text-lg leading-snug text-neutral-200 md:text-xl" data-id="element-181" data-mp="2hmzkro16p61z">
              <XIcon className="h-5 w-5 shrink-0 text-red-400" strokeWidth={3} aria-hidden="true" data-id="element-182" data-mp="28tctaa40eoyl" />
              {p}
            </li>)}
        </ul>
        <p className="mt-14 text-center font-display text-2xl font-black uppercase leading-tight text-cream md:text-4xl" data-id="element-183" data-mp="1yu3zbh959ac8">
          ¿Y si esta fuera la <span className="text-gold" data-id="element-184" data-mp="1twlsbweot56v">última vez</span> que empezás desde cero?
        </p>
      </div>
    </section>;
}